import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(pages)/market/@trend/page.tsx");
